module.exports = __webpack_public_path__ + "static/logo300px-efce6934335a6f0c52cdfce7403bc833.png";